import { MenuItemChangeAvailabilityButton } from "../MenuItemChangeAvailabilityButton"
import { MenuItemUserData } from "../MenuItemUserData"
import { MenuDivider } from "@mantine/core"

export function MenuSectionDJUI() {
  return (
    <>
      <MenuItemUserData />
      <MenuDivider />
      <MenuItemChangeAvailabilityButton />
      {/* <MenuItemChangeWebphoneModeButton /> */}
      <MenuDivider />
    </>
  )
}
